/*=========================================================================================
  File Name: state.js
  Description: Ordering Actions
  ----------------------------------------------------------------------------------------
  Item Name: Ordering State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/ordering/queries'
import commands from '../../../services/ordering/commands'
import TimeFormatter from '../../../common/utils/TimeFormatter'
export default {

  async getPickupNumberAction( {commit, state, rootState }, payload ) {

    //let restaurantId = rootState.auth.auth.restaurantId;
    let restaurantId = payload.restaurantId;
    let token = rootState.auth.auth.token;

    await queries.getPickupNumberByRestaurant(restaurantId)
                 .then( data => {
                   commit('SET_PICKUPNUMBER_STATE', data)
                 });
  },

  async createOrderByPhoneAction( {commit, getters, state, rootState}, payload) {

    let restaurantId = payload.restaurantId;
    let token = rootState.auth.auth.token;
    let cart = [];
   
    state.cart.forEach(item => {
      // let newOptions = '';
      // let shortDescription = '';
      // let separator = ' - ';
      // let index = 0;
      // item.options.forEach(o => {
      //   newOptions += o.description + ':' + o.options + ' (+' + o.addedPrice + 'kr)';
      //   shortDescription += o.options
      //   if(item.options.length - index > 1) {
      //     newOptions += separator;
      //     shortDescription += separator;
      //   }
      // });
      let newItem = {
        index : item.index,
        itemId : item.itemId,
        itemName : item.itemName,
        quantity : item.quantity,
        categoryName : item.categoryName,
        itemPrice : item.price + item.addedPrice,
        addedPrice : item.addedPrice,
        discount : item.discount,
        tax: item.tax,
        options : JSON.stringify(item.options),
        shortDescription : item.shortDescription,
        comment : item.comment
      };
      cart.push(newItem);
    });
    
    let order = {
      restaurantId : restaurantId,
      pickupNumber : state.pickupNumber,
      amount : getters.amount,
      comment : state.comment,
      customerName : state.customerName,
      phoneNumber : state.phoneNumber,
      pickupTime : TimeFormatter.timeToString(state.pickupTime),
      estimatedTime : state.estimatedTime,
      totalItems : state.totalItems,
      priority : state.priority,
      asap : state.ASAP,
      cart: cart,
    }
    console.log(order)
    await commands.createOrderByPhoneService(order)
                  .then( data => {
                    console.log(data)
                  });
  }

  
}